import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4367524d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4367524d')) {
      api.createRecord('4367524d', component.options)
    } else {
      api.reload('4367524d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4367524d&", function () {
      api.rerender('4367524d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/range-date/index.vue"
export default component.exports